import React, { useState } from 'react';
import FAQPage from '../components/faq-page.component';
import Header from '../components/header.component';
import { AccountAccess } from '../components/account-access.component';
import { Footer } from '../components/footer.component';
import SectionHeader from '../components/common';
import { useTranslation } from 'react-i18next';
import { Container } from 'react-bootstrap';
import { SearchInput } from '../components/search/search-input.components';
import { Search } from '../components/images/png/icons';
import '../scss/main.scss'
import SEOMetadataComponent from '../components/seo-metadata.component';
import { LOCALES } from '../../common/constants';
import { getSchemaMarkup } from "../../common/FunctionUtils";

export const FaqPage: React.FC = () => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;
    const isEnglish = currentLanguage === 'en' || currentLanguage === LOCALES.EN_US;

    const [searchQuery, setSearchQuery] = useState('');

    // Dynamic canonical URL based on language (like router)
    const canonicalUrl = isEnglish
        ? `https://www.invozio.com/faq?lang=${LOCALES.EN_US}`
        : `https://www.invozio.com/faq?lang=${LOCALES.SV_SE}`;

    const handleSearch = (e: React.FormEvent) => {
        e.preventDefault();
        // trigger search logic here
    };
  const schemaMarkup = getSchemaMarkup("faq");

    return (
        <div className="faq-page-demo">
            <Header />
            <SEOMetadataComponent
                title={t('FAQ_MAIN_TITLE')}
                description={t('FAQ_SUBTITLE')}
                canonicalUrl={canonicalUrl}
                noindex={false}
                robots="index, follow"
                schemaMarkup={schemaMarkup}
            />
            <SectionHeader
                titleKey={t('FAQ_MAIN_TITLE')}
                subtitleKey={t('FAQ_SUBTITLE')}
                className="invozio-news-section"
                titleClassName="main-title"
                subtitleClassName="sub-title"
                alignment="center"
            />
            <section className="news-search">
                <Container>
                    <div className="news-search-container">
                        <SearchInput
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onSubmit={handleSearch}
                            placeholder={t("SEARCH_PLACEHOLDER")}
                            iconSrc={Search}
                            altText={t("ALT_SEARCH")}
                            className="news-search-form"
                            inputClassName="news-search-input"
                        />
                    </div>
                </Container>
            </section>
            <FAQPage searchQuery={searchQuery} />
            <div className="bg-footer">
                <AccountAccess />
                <Footer />
            </div>

        </div>
    );
};

export default FaqPage;
